import { DIMENSION } from '@adtrackify/at-tracking-event-types';

export const DIMENSION_DISPLAY_LABELS: Partial<Record<DIMENSION, string>> = {
  [DIMENSION.UTM_SOURCE]: 'Source',
  [DIMENSION.UTM_MEDIUM]: 'Medium',
  [DIMENSION.UTM_CAMPAIGN]: 'Campaign',
  [DIMENSION.UTM_TERM]: 'Ad Set',
  [DIMENSION.UTM_CONTENT]: 'Ad',
  [DIMENSION.UTM_SOURCE_CAMPAIGN]: 'Source Campaign',
  [DIMENSION.UTM_SOURCE_MEDIUM]: 'Source Medium',
  [DIMENSION.UTM_ADSET]: 'Ad Set',
  [DIMENSION.UTM_AD]: 'Ad',
  [DIMENSION.ORDER]: 'Order',
  [DIMENSION.NEW_CUSTOMER_ORDER]: 'New Customer Order',
};

export const ATTRIBUTION_EVENTS = {
  PAGE_VIEW: 'page_view',
  VIEW_CONTENT: 'view_content',
  ADD_TO_CART: 'add_to_cart',
  INITIATE_CHECKOUT: 'initiate_checkout',
  PURCHASE: 'purchase',
  LEAD: 'lead',
} as const;

export const CONVERSION_VALUE_SOURCES = {
  ORDERS: 'orders',
  EVENTS: 'events',
} as const;

export const ATTRIBUTION_TAB_HIERARCHY: DIMENSION[] = [
  DIMENSION.UTM_SOURCE,
  DIMENSION.UTM_CAMPAIGN,
  DIMENSION.UTM_TERM,
  DIMENSION.UTM_CONTENT,
];

